import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { datadogLogs } from "@datadog/browser-logs";
import courseApprovalService from "@/services/courseApproval.js";
import { queryKeys } from "../constants";
import { processInBatches } from "./utils.js";

export const useDeleteCourseApproval = (throttleLimit = 3) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (deleteCourseApprovalIds) => {
      return processInBatches(deleteCourseApprovalIds, throttleLimit, (deleteCourseApprovalId) =>
        courseApprovalService.deleteCourse(deleteCourseApprovalId)
      );
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: queryKeys.courseEquivalencies.all });
    },
    onError: (error, variables) => {
      datadogLogs.logger.error("Failed to delete course approval", {
        error: error.message,
        courseApprovalCount: variables.length,
      });
    },
  });
};
